var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 95.05 95.05"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.46 19.46a5.42 5.42 0 000-7.67l-10.2-10.2a5.42 5.42 0 00-7.67 0L47.52 29.66 19.46 1.59a5.42 5.42 0 00-7.67 0l-10.2 10.2a5.42 5.42 0 000 7.67l28.07 28.07L1.59 75.59a5.42 5.42 0 000 7.67l10.2 10.2a5.42 5.42 0 007.67 0l28.07-28.07L75.6 93.46a5.42 5.42 0 007.67 0l10.2-10.2a5.42 5.42 0 000-7.67L65.4 47.52l28.07-28.07z",
    fill: "#e54061"
  })));
}
export default SvgRedX;